import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MutualLogo = _resolveComponent("MutualLogo")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_NotificationIcon = _resolveComponent("NotificationIcon")!
  const _component_m_btn = _resolveComponent("m-btn")!
  const _component_ProfilePicture = _resolveComponent("ProfilePicture")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_SpeedNav = _resolveComponent("SpeedNav")!
  const _component_AppSettings = _resolveComponent("AppSettings")!
  const _component_NotificationBar = _resolveComponent("NotificationBar")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode("todo: put this into a 'header' component"),
    _createVNode(_component_v_app, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_layout, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_app_bar, {
              elevation: 1,
              density: "compact"
            }, {
              prepend: _withCtx(() => [
                _createVNode(_component_MutualLogo)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_app_bar_title, { class: "text-start" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($setup.routeTitle), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_NotificationIcon),
                _createVNode(_component_m_btn, {
                  icon: "mdi-cog",
                  onClick: $setup.showSettings,
                  variant: "text"
                }, null, 8 /* PROPS */, ["onClick"]),
                _createVNode(_component_m_btn, { variant: "text" }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_ProfilePicture)
                  ]),
                  append: _withCtx(() => [
                    _createTextVNode(_toDisplayString($setup.authStore.getName), 1 /* TEXT */)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_menu, {
                      "offset-y": "",
                      activator: "parent"
                    }, {
                      default: _withCtx(() => [
                        _createCommentVNode(" Menu content "),
                        _createVNode(_component_v_list, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item, {
                              button: "",
                              onClick: $setup.logout
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                                    _createTextVNode("Log out")
                                  ])),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"])
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_navigation_drawer, {
              permanent: "",
              modelValue: $setup.drawer,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.drawer) = $event)),
              rail: $setup.rail,
              elevation: "5",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.rail = !$setup.rail)),
              width: "320"
            }, {
              append: _withCtx(() => [
                _createVNode(_component_v_container, { fluid: "" }, {
                  default: _withCtx(() => [
                    (!$setup.rail)
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 0,
                          justify: "end"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              icon: "mdi-chevron-left",
                              variant: "text",
                              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.rail = !$setup.rail), ["stop"]))
                            })
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true),
                    _createVNode(_component_v_row, { justify: "center" }, {
                      default: _withCtx(() => [
                        ($setup.rail)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              icon: "mdi-chevron-right",
                              variant: "text",
                              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($setup.rail = !$setup.rail), ["stop"]))
                            }))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_list, {
                  density: "compact",
                  class: "mt-3",
                  nav: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item, {
                      class: "text-start",
                      value: "Underwriter Workbench",
                      href: "/workbench",
                      "prepend-icon": "mdi-tools",
                      title: "Underwriter Workbench"
                    }),
                    _createVNode(_component_v_list_item, {
                      class: "text-start",
                      value: "Batch Dashboard",
                      href: "/batch-dashboard",
                      "prepend-icon": "mdi-play-box-multiple",
                      title: "Batch Dashboard"
                    }),
                    _createVNode(_component_v_list_item, {
                      class: "text-start",
                      value: "Policy Form Trackers",
                      href: "/policy-form-trackers",
                      "prepend-icon": "mdi-file-document-multiple",
                      title: "Policy Form Trackers"
                    }),
                    _createCommentVNode(" 2025.06.22 - BSU\n\t\t\t\t\tThis will come back into play when the policy is kept in context between pages"),
                    _createCommentVNode(" <v-list-item class=\"text-start\" value=\"Fix My Policy\" href=\"/policy-fix\" prepend-icon=\"mdi-auto-fix\"\n\t\t\t\t\t\ttitle=\"Fix My Policy\">\n\t\t\t\t\t</v-list-item> ")
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue", "rail"]),
            _createVNode(_component_v_main, {
              id: "main-content",
              class: "d-flex justify-center flex-wrap ma-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_router_view),
                _createVNode(_component_SpeedNav),
                _createVNode(_component_AppSettings, {
                  isActive: $setup.settingsOn,
                  onClosed: $setup.settingsClosed
                }, null, 8 /* PROPS */, ["isActive", "onClosed"]),
                _createVNode(_component_NotificationBar)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    })
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}